import { useState, useEffect } from "react";

function useSelectedMPCountry(marketPackage, country, editTarget) {
    const [activeKey, setactiveKey] = useState(null);
    const [selectedCountry, setselectedCountry] = useState(null);
    const [selectedMP, setselectedMP] = useState(null);

    useEffect(() => { // Set initial state if edit mode.
        if (marketPackage) {
            setselectedMP(() => marketPackage);
            if (editTarget) {
                setactiveKey(() => marketPackage.parent.key);
            }
        }
        if (country) {
            setselectedCountry(() => country);
        }
    }, [marketPackage, country, editTarget]);

    return {
        activeKey,
        selectedCountry,
        selectedMP,
        setactiveKey,
        setselectedCountry,
        setselectedMP
    };
}

export default useSelectedMPCountry;
